var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.info.show,
      "modal-append-to-body": false,
      "width": "640px",
      "top": "8vh",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.displayPrePosition,
            expression: "displayPrePosition"
          }],
          staticClass: "el-icon-arrow-left pointer",
          on: {
            "click": function ($event) {
              _vm.displayPrePosition = false;
            }
          }
        }), _c('span', [_vm._v(_vm._s(_vm.displayPrePosition ? _vm.$t('anywhereSetting.preposition') : _vm.$t('anywhereSetting.setting')))]), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.operationStatus,
            expression: "operationStatus"
          }],
          class: ['operation-status', _vm.operationStatus]
        }, [_c('i', {
          class: _vm.operationStatus == 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close'
        }), _c('span', [_vm._v(_vm._s(_vm.operationMessage))])])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "topContent"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "headLeft"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("kioskHost.sourceType")) + ":")]), _c('span', {
    staticClass: "sourceContent"
  }, [_vm._v(_vm._s(_vm.deviceType == 'Anywhere' ? _vm.$t("anywhereSetting.tvuAnywhere") : _vm.$t("anywhereSetting.partylineApp")))])]), _c('div', {
    staticClass: "headRight"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.pid")) + ":")]), _c('span', {
    staticClass: "pidContent"
  }, [_vm._v(_vm._s(_vm.peerId))])])]), _c('div', {
    staticClass: "videoBox"
  }, [_vm.isSupportGimbal == '1' ? _c('div', {
    staticClass: "gimBalBox"
  }, [_c('div', {
    staticClass: "ringContent"
  }, [_c('img', {
    staticClass: "up",
    style: {
      opacity: _vm.isTopPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/up.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(0);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "down",
    style: {
      opacity: _vm.isBottomPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/down.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(1);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "left",
    style: {
      opacity: _vm.isLeftPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/left.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(2);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "right",
    style: {
      opacity: _vm.isRightPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/right.svg")
    },
    on: {
      "mousedown": function ($event) {
        return _vm.handleMousedown(3);
      },
      "mouseup": _vm.handleMouseup,
      "mouseleave": _vm.handleMouseLeave
    }
  }), _c('img', {
    staticClass: "center",
    style: {
      opacity: _vm.isCenterPressed ? '0.6' : '1'
    },
    attrs: {
      "src": require("@/assets/img/reset.svg")
    },
    on: {
      "click": _vm.resetGimBal
    }
  }), _c('img', {
    staticClass: "ring",
    attrs: {
      "src": require("@/assets/img/ring.svg")
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "video"
  }, [_c('div', {
    staticClass: "topBox"
  }, [_vm.isRecording == '1' ? _c('div', {
    staticClass: "recContent"
  }, [_c('div', {
    staticClass: "rec-dot"
  }), _c('div', {
    staticClass: "rec-text"
  }, [_vm._v("REC")]), _c('div', {
    staticClass: "timer"
  }, [_vm._v(_vm._s(_vm.formattedTime))])]) : _vm._e(), _c('div', {
    staticClass: "location"
  }, [_c('i', {
    staticClass: "el-icon-location-outline",
    staticStyle: {
      "font-size": "18px"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.location,
      "placement": "top"
    }
  }, [_c('span', {
    staticClass: "location-text"
  }, [_vm._v(_vm._s(_vm.location))])])], 1)]), _c('NewAttendUser', {
    ref: "attendUser",
    attrs: {
      "muteAudio": _vm.muteAudio,
      "singChannel": _vm.singChannel,
      "degreeHost": _vm.degreeHost,
      "userInfo": _vm.userInfo,
      "rtc": _vm.rtc,
      "anywhereSetting": true
    }
  })], 1), _c('div', {
    staticClass: "volume"
  }, [_c('canvas', {
    staticClass: "volumeLeft"
  }), _c('canvas', {
    staticClass: "volumeRight"
  }), _c('img', {
    attrs: {
      "src": require('@/assets/img/volume.svg')
    }
  })])])]), _c('div', {
    staticClass: "scrollableContent"
  }, [_c('div', {
    staticClass: "centerContent"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayPrePosition,
      expression: "displayPrePosition"
    }],
    staticClass: "prePositionName"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.prepositionName")) + ":")]), !_vm.isEditing ? _c('span', {
    staticClass: "value",
    on: {
      "click": _vm.startEditing
    }
  }, [_vm._v(_vm._s(_vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].name))]) : _c('el-input', {
    ref: "nameInput",
    staticClass: "edit-input",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.saveEdit
    },
    model: {
      value: _vm.editedName,
      callback: function ($$v) {
        _vm.editedName = $$v;
      },
      expression: "editedName"
    }
  }), !_vm.isEditing ? _c('i', {
    staticClass: "el-icon-edit",
    on: {
      "click": _vm.startEditing
    }
  }) : _vm._e()], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayPrePosition,
      expression: "displayPrePosition"
    }],
    staticClass: "positionDegree"
  }, [_c('div', {
    staticClass: "verticalSelect"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.upDown")))]), _c('el-input', {
    attrs: {
      "min": _vm.anyWhereSetObj.gimbalAngleRange && -Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[1].max),
      "max": _vm.anyWhereSetObj.gimbalAngleRange && +Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[0].max)
    },
    on: {
      "change": function ($event) {
        return _vm.changePresetPosition('upDown', $event);
      }
    },
    model: {
      value: _vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].upDown,
      callback: function ($$v) {
        _vm.$set(_vm.presetPositions[_vm.activeType === 'first' ? 0 : 1], "upDown", $$v);
      },
      expression: "presetPositions[activeType === 'first' ? 0 : 1].upDown"
    }
  }), _c('i', {
    staticClass: "degree-range"
  }, [_vm._v("+" + _vm._s(_vm.anyWhereSetObj.gimbalAngleRange && Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[0].max)) + "° ~ -" + _vm._s(_vm.anyWhereSetObj.gimbalAngleRange && Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[1].max)) + "°")])], 1), _c('div', {
    staticClass: "horizontalSelect"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.leftRight")))]), _c('el-input', {
    attrs: {
      "min": _vm.anyWhereSetObj.gimbalAngleRange && -Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[2].max),
      "max": _vm.anyWhereSetObj.gimbalAngleRange && +Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[3].max)
    },
    on: {
      "change": function ($event) {
        return _vm.changePresetPosition('leftRight', $event);
      }
    },
    model: {
      value: _vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].leftRight,
      callback: function ($$v) {
        _vm.$set(_vm.presetPositions[_vm.activeType === 'first' ? 0 : 1], "leftRight", $$v);
      },
      expression: "presetPositions[activeType === 'first' ? 0 : 1].leftRight"
    }
  }), _c('i', {
    staticClass: "degree-range"
  }, [_vm._v("-" + _vm._s(_vm.anyWhereSetObj.gimbalAngleRange && Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[2].max)) + "° ~ +" + _vm._s(_vm.anyWhereSetObj.gimbalAngleRange && Number(JSON.parse(_vm.anyWhereSetObj.gimbalAngleRange)[3].max)) + "°")])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayPrePosition,
      expression: "displayPrePosition"
    }],
    staticClass: "zoomContent"
  }, [_c('span', {
    staticClass: "zoomText"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.zoomText")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.1,
      "min": _vm.anyWhereSetObj.zoomRange && Number(JSON.parse(_vm.anyWhereSetObj.zoomRange).zoomMin),
      "max": _vm.anyWhereSetObj.zoomRange && Number(JSON.parse(_vm.anyWhereSetObj.zoomRange).zoomMax),
      "disabled": _vm.isDisabled('zoom') || _vm.isDisabled('zoomRange')
    },
    on: {
      "change": _vm.changePresetZoomInputValue
    },
    model: {
      value: _vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].zoom,
      callback: function ($$v) {
        _vm.$set(_vm.presetPositions[_vm.activeType === 'first' ? 0 : 1], "zoom", $$v);
      },
      expression: "presetPositions[activeType === 'first' ? 0 : 1].zoom"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false,
      "disabled": _vm.isDisabled('zoom') || _vm.isDisabled('zoomRange')
    },
    on: {
      "change": _vm.changePresetZoomInputValue,
      "input": function ($event) {
        _vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].zoom = Number(_vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].zoom);
      }
    },
    model: {
      value: _vm.presetPositions[_vm.activeType === 'first' ? 0 : 1].inputZoom,
      callback: function ($$v) {
        _vm.$set(_vm.presetPositions[_vm.activeType === 'first' ? 0 : 1], "inputZoom", $$v);
      },
      expression: "presetPositions[activeType === 'first' ? 0 : 1].inputZoom"
    }
  }), _c('i', {
    staticClass: "zoomSymbol"
  }), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "padding-left": "5px",
      "cursor": "pointer"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.reset'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh-left",
    on: {
      "click": function ($event) {
        return _vm.changePresetZoomInputValue(1, true);
      }
    }
  })])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition,
      expression: "!displayPrePosition"
    }],
    staticClass: "operation",
    style: {
      'display': _vm.deviceType == 'App' ? 'flex' : 'grid'
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('resolution') && !_vm.isDisabled('resolutionOptions'),
      expression: "!isDisabled('resolution') && !isDisabled('resolutionOptions')"
    }],
    staticClass: "resolutionBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("commonSetting.resolution")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('resolutionFps', _vm.resolution);
      }
    },
    model: {
      value: _vm.resolution,
      callback: function ($$v) {
        _vm.resolution = $$v;
      },
      expression: "resolution"
    }
  }, _vm._l(_vm.computedResolutionOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.anyWhereSetObj['resolutionList'],
      expression: "anyWhereSetObj['resolutionList']"
    }],
    staticClass: "resolutionBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("commonSetting.resolution")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('macResolution', _vm.resolution);
      }
    },
    model: {
      value: _vm.resolution,
      callback: function ($$v) {
        _vm.resolution = $$v;
      },
      expression: "resolution"
    }
  }, _vm._l(_vm.resolutionList, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('fps') && !_vm.isDisabled('fpsOptions'),
      expression: "!isDisabled('fps') && !isDisabled('fpsOptions')"
    }],
    staticClass: "framesRateBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.framesRate")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('resolutionFps');
      }
    },
    model: {
      value: _vm.fps,
      callback: function ($$v) {
        _vm.fps = $$v;
      },
      expression: "fps"
    }
  }, _vm._l(_vm.computedFpsOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.anyWhereSetObj['resolutionList'],
      expression: "anyWhereSetObj['resolutionList']"
    }],
    staticClass: "framesRateBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.framesRate")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('macFps');
      }
    },
    model: {
      value: _vm.fps,
      callback: function ($$v) {
        _vm.fps = $$v;
      },
      expression: "fps"
    }
  }, _vm._l(_vm.fpsList, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('cameraPosition'),
      expression: "!isDisabled('cameraPosition')"
    }],
    staticClass: "switchCameraBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.switchCamera")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('switchCamera');
      }
    },
    model: {
      value: _vm.cameraPosition,
      callback: function ($$v) {
        _vm.cameraPosition = $$v;
      },
      expression: "cameraPosition"
    }
  }, _vm._l(_vm.computedCameraOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`anywhereSetting.${item.label}`),
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.anyWhereSetObj['videoDeviceList'],
      expression: "anyWhereSetObj['videoDeviceList']"
    }],
    staticClass: "switchCameraBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.switchCamera")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('switchVideoSource');
      }
    },
    model: {
      value: _vm.cameraPosition,
      callback: function ($$v) {
        _vm.cameraPosition = $$v;
      },
      expression: "cameraPosition"
    }
  }, _vm._l(_vm.computedMacCameraOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('defaultView'),
      expression: "!isDisabled('defaultView')"
    }],
    staticClass: "defaultViewBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.defaultView")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('defaultView');
      }
    },
    model: {
      value: _vm.defaultView,
      callback: function ($$v) {
        _vm.defaultView = $$v;
      },
      expression: "defaultView"
    }
  }, _vm._l(_vm.defaultViewOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`anywhereSetting.${item.label}`),
        "value": item.value
      }
    });
  }), 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('audioDeviceID'),
      expression: "!isDisabled('audioDeviceID')"
    }],
    staticClass: "switchMicBox"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.switchMic")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('switchAudioSource');
      }
    },
    model: {
      value: _vm.micPosition,
      callback: function ($$v) {
        _vm.micPosition = $$v;
      },
      expression: "micPosition"
    }
  }, _vm._l(_vm.computedMicOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    });
  }), 1)], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition,
      expression: "!displayPrePosition"
    }],
    staticClass: "record"
  }, [_c('div', {
    staticClass: "recordText"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.recordText")) + ":")]), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "padding-left": "4px"
    },
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticStyle: {
      "width": "260px"
    }
  }, [_vm._v(_vm._s(_vm.$t('anywhereSetting.recordTips')))])]), _c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('div', {
    staticClass: "recordSetting"
  }, [_vm.isRecording == '1' ? _c('div', {
    staticClass: "timer"
  }, [_vm._v(_vm._s(_vm.formattedTime))]) : _vm._e(), _c('el-button', {
    class: _vm.isRecording == '0' ? 'green' : 'red',
    attrs: {
      "loading": _vm.recordLoading
    },
    on: {
      "click": function ($event) {
        return _vm.changeProperty('recordStatus');
      }
    }
  }, [_vm._v(_vm._s(_vm.isRecording == '0' ? _vm.$t('anywhereSetting.startRecord') : _vm.$t('anywhereSetting.stopRecord')))])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition && _vm.isSupportGimbal == '1' && _vm.isSupportPreSetBtn,
      expression: "!displayPrePosition && isSupportGimbal == '1' && isSupportPreSetBtn"
    }],
    staticClass: "position"
  }, [_c('div', {
    staticClass: "positionText"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.positionText")) + ":")]), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "padding-left": "4px"
    },
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticStyle: {
      "width": "260px"
    }
  }, [_vm._v(_vm._s(_vm.$t('anywhereSetting.positionTips')))])]), _c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('div', {
    staticClass: "positionSetting"
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": !_vm.initPosition[0] ? _vm.$t('anywhereSetting.positionBtnDisabledTips') : _vm.$t('anywhereSetting.positionBtnActiveTips')
    }
  }, [_c('el-button', {
    class: _vm.isMatchPositionOne ? 'green' : '',
    attrs: {
      "loading": _vm.loading['first'],
      "disabled": !_vm.initPosition[0] || _vm.loading.second
    },
    on: {
      "click": function ($event) {
        return _vm.applyPosition('first');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.presetPositions[0] ? _vm.presetPositions[0].name : _vm.$t('anywhereSetting.positionOne')) + " ")])], 1), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('anywhereSetting.positionSetting')
    }
  }, [_c('i', {
    staticClass: "el-icon-setting pointer",
    on: {
      "click": function ($event) {
        return _vm.openPosition('first');
      }
    }
  })]), _c('el-divider', {
    staticClass: "dividers",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": !_vm.initPosition[1] ? _vm.$t('anywhereSetting.positionBtnDisabledTips') : _vm.$t('anywhereSetting.positionBtnActiveTips')
    }
  }, [_c('el-button', {
    class: _vm.isMatchPositionTwo ? 'green' : '',
    attrs: {
      "loading": _vm.loading['second'],
      "disabled": !_vm.initPosition[1] || _vm.loading.first
    },
    on: {
      "click": function ($event) {
        return _vm.applyPosition('second');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.presetPositions[1] ? _vm.presetPositions[1].name : _vm.$t('anywhereSetting.positionTwo')) + " ")])], 1), _c('el-tooltip', {
    attrs: {
      "placement": "top",
      "content": _vm.$t('anywhereSetting.positionSetting')
    }
  }, [_c('i', {
    staticClass: "el-icon-setting pointer",
    on: {
      "click": function ($event) {
        return _vm.openPosition('second');
      }
    }
  })]), _c('el-divider', {
    staticClass: "dividers",
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-button', {
    staticClass: "positionTwo",
    class: !_vm.isMatchPositionTwo && !_vm.isMatchPositionOne ? 'green' : ''
  }, [_vm._v(_vm._s(_vm.$t('anywhereSetting.manualSet')))])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition && !_vm.isDisabled('speakerVolume'),
      expression: "!displayPrePosition && !isDisabled('speakerVolume')"
    }],
    staticClass: "speakerContent",
    style: {
      'padding-top': _vm.isSupportGimbal == '1' ? '' : '18px'
    }
  }, [_c('span', {
    staticClass: "zoomText"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.speakerText")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.1,
      "min": 0,
      "max": 100
    },
    on: {
      "change": _vm.changeSpeakerVolumeInputValue
    },
    model: {
      value: _vm.speakerVolume,
      callback: function ($$v) {
        _vm.speakerVolume = $$v;
      },
      expression: "speakerVolume"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": _vm.changeSpeakerVolumeInputValue,
      "input": function ($event) {
        _vm.speakerVolume = Number(_vm.speakerVolume);
      }
    },
    model: {
      value: _vm.inputVolume,
      callback: function ($$v) {
        _vm.inputVolume = $$v;
      },
      expression: "inputVolume"
    }
  }), _c('i', {
    staticClass: "volumeSymbol"
  }, [_vm._v("%")]), _vm.speakerStatus ? _c('i', {
    staticClass: "iconfont icon-a-V2speakeron",
    on: {
      "click": function ($event) {
        return _vm.changeSpeakerStatus(0, 'speakerStatus');
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2speakeroff",
    on: {
      "click": function ($event) {
        return _vm.changeSpeakerStatus(1, 'speakerStatus');
      }
    }
  }), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "padding-left": "5px",
      "cursor": "pointer"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.reset'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh-left",
    on: {
      "click": function ($event) {
        return _vm.changeSpeakerVolumeInputValue(100, true);
      }
    }
  })])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition && !_vm.isDisabled('zoom') && !_vm.isDisabled('zoomRange'),
      expression: "!displayPrePosition && !isDisabled('zoom') && !isDisabled('zoomRange')"
    }],
    staticClass: "zoomContent"
  }, [_c('span', {
    staticClass: "zoomText"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.zoomText")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.1,
      "min": _vm.anyWhereSetObj.zoomRange && Number(JSON.parse(_vm.anyWhereSetObj.zoomRange).zoomMin),
      "max": _vm.anyWhereSetObj.zoomRange && Number(JSON.parse(_vm.anyWhereSetObj.zoomRange).zoomMax)
    },
    on: {
      "change": _vm.changeZoomInputValue
    },
    model: {
      value: _vm.zoom,
      callback: function ($$v) {
        _vm.zoom = $$v;
      },
      expression: "zoom"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": _vm.changeZoomInputValue,
      "input": function ($event) {
        _vm.zoom = Number(_vm.zoom);
      }
    },
    model: {
      value: _vm.inputZoom,
      callback: function ($$v) {
        _vm.inputZoom = $$v;
      },
      expression: "inputZoom"
    }
  }), _c('i', {
    staticClass: "zoomSymbol"
  }), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "padding-left": "5px",
      "cursor": "pointer"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.reset'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh-left",
    on: {
      "click": function ($event) {
        return _vm.changeZoomInputValue(1, true);
      }
    }
  })])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition && !_vm.isDisabled('whiteBalanceAuto'),
      expression: "!displayPrePosition && !isDisabled('whiteBalanceAuto')"
    }],
    staticClass: "autoWhiteBalance"
  }, [_c('div', {
    staticClass: "autoWhiteBalanceTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.autoWhiteBalance")))])]), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('whiteBalanceAuto');
      }
    },
    model: {
      value: _vm.whiteBalanceAuto,
      callback: function ($$v) {
        _vm.whiteBalanceAuto = $$v;
      },
      expression: "whiteBalanceAuto"
    }
  })], 1), _vm.whiteBalanceAuto == '0' && !_vm.displayPrePosition ? _c('div', {
    staticClass: "whiteBalanceContent"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('whiteBalanceRange'),
      expression: "!isDisabled('whiteBalanceRange')"
    }],
    staticClass: "whiteBalance"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.balance")) + ":")]), _c('div', {
    staticClass: "whiteBalanceContent"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.scenes")) + ":")]), _c('el-select', {
    attrs: {
      "popper-class": "elPopperClass",
      "placeholder": "select"
    },
    on: {
      "change": _vm.changeWhiteBalanceAuto
    },
    model: {
      value: _vm.whiteBalanceType,
      callback: function ($$v) {
        _vm.whiteBalanceType = $$v;
      },
      expression: "whiteBalanceType"
    }
  }, [_c('div', {
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_c('span', {
    staticStyle: {
      "padding": "2px",
      "line-height": "33px",
      "font-size": "18px",
      "color": "#33ab4f"
    }
  }, [_c('i', {
    class: _vm.getIconClass(_vm.whiteBalanceType),
    style: {
      'font-size': '20px'
    }
  })])]), _vm._l(_vm.whiteBalanceOptions, function (item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label,
        "disabled": item.label == 'Manual' && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMax == 0 && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMin == 0 && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMax == 0 && JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMin == 0
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('span', {
      staticStyle: {
        "padding-right": "5px"
      }
    }, [_c('i', {
      class: _vm.getIconClass(item.label),
      staticStyle: {
        "font-size": "20px"
      }
    })]), _c('span', [_vm._v(_vm._s(item.label))])])]);
  })], 2), _c('el-tooltip', {
    staticClass: "item",
    staticStyle: {
      "width": "20%",
      "padding-left": "4px"
    },
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.scenesTips'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.platForm != '11' && !_vm.isDisabled('whiteBalanceRange'),
      expression: "platForm != '11' && !isDisabled('whiteBalanceRange')"
    }],
    staticClass: "colorControl"
  }, [_c('div', {
    staticClass: "colorTemperature"
  }, [_c('span', {
    staticClass: "temeperature"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.temperature")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMin),
      "max": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tempMax)
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.temperature, 'temperature');
      }
    },
    model: {
      value: _vm.temperature,
      callback: function ($$v) {
        _vm.temperature = $$v;
      },
      expression: "temperature"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputTemperature, 'temperature');
      },
      "input": function ($event) {
        _vm.temperature = Number(_vm.temperature);
      }
    },
    model: {
      value: _vm.inputTemperature,
      callback: function ($$v) {
        _vm.inputTemperature = $$v;
      },
      expression: "inputTemperature"
    }
  })], 1)]), _c('div', {
    staticClass: "colorTints"
  }, [_c('span', {
    staticClass: "tints"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.tints")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "min": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMin),
      "max": _vm.anyWhereSetObj.whiteBalanceRange && Number(JSON.parse(_vm.anyWhereSetObj.whiteBalanceRange).tintMax)
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.tints, 'tint');
      }
    },
    model: {
      value: _vm.tints,
      callback: function ($$v) {
        _vm.tints = $$v;
      },
      expression: "tints"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputTints, 'tint');
      },
      "input": function ($event) {
        _vm.tints = Number(_vm.tints);
      }
    },
    model: {
      value: _vm.inputTints,
      callback: function ($$v) {
        _vm.inputTints = $$v;
      },
      expression: "inputTints"
    }
  })], 1)])])]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displayPrePosition,
      expression: "!displayPrePosition"
    }],
    staticClass: "bottomContent"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('lock'),
      expression: "!isDisabled('lock')"
    }],
    staticClass: "lockApp"
  }, [_c('div', {
    staticClass: "lockAppTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.lockApp", {
    deceiveType: _vm.deviceType == 'Anywhere' ? 'TVU Anywhere' : 'TVU Partyline'
  })))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('anywhereSetting.lockAppTips', {
        deceiveType: _vm.deviceType == 'Anywhere' ? 'TVU Anywhere' : 'TVU Partyline'
      }),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help2"
  })])], 1), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('lockScreen');
      }
    },
    model: {
      value: _vm.locked,
      callback: function ($$v) {
        _vm.locked = $$v;
      },
      expression: "locked"
    }
  })], 1), _c('div', {
    staticClass: "autoFocus"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('autoFocus') && Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax) != 0,
      expression: "!isDisabled('autoFocus') && Number(\n                  JSON.parse(anyWhereSetObj.focusDistanceRange).focusMax\n                ) != 0"
    }],
    staticClass: "autoFocusSwitch"
  }, [_c('div', {
    staticClass: "autoFocusTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.autoFocus")))])]), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('autoFocus');
      }
    },
    model: {
      value: _vm.autoFocus,
      callback: function ($$v) {
        _vm.autoFocus = $$v;
      },
      expression: "autoFocus"
    }
  })], 1), _vm.autoFocus == '0' && !_vm.isDisabled('focusDistanceRange') && !_vm.isDisabled('focusDistance') && Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax) != 0 ? _c('div', {
    staticClass: "autoFocusValue"
  }, [_c('span', {
    staticClass: "focus"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.focusValue")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.01,
      "min": _vm.anyWhereSetObj.focusDistanceRange && Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMin),
      "max": _vm.anyWhereSetObj.focusDistanceRange && Number(JSON.parse(_vm.anyWhereSetObj.focusDistanceRange).focusMax)
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.focus, 'focus');
      }
    },
    model: {
      value: _vm.focus,
      callback: function ($$v) {
        _vm.focus = $$v;
      },
      expression: "focus"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputFocus, 'focus');
      },
      "input": function ($event) {
        _vm.focus = Number(_vm.focus);
      }
    },
    model: {
      value: _vm.inputFocus,
      callback: function ($$v) {
        _vm.inputFocus = $$v;
      },
      expression: "inputFocus"
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "autoExposure"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDisabled('autoExposure') && Number(JSON.parse(_vm.anyWhereSetObj.exposureRange).exposureMax) != 0,
      expression: "!isDisabled('autoExposure') &&\n                Number(\n                  JSON.parse(anyWhereSetObj.exposureRange).exposureMax\n                ) != 0"
    }],
    staticClass: "autoFocusSwitch"
  }, [_c('div', {
    staticClass: "autoFocusTitle"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("anywhereSetting.autoExposure")))])]), _c('el-switch', {
    attrs: {
      "active-value": '1',
      "inactive-value": '0',
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": function ($event) {
        return _vm.changeProperty('autoExposure');
      }
    },
    model: {
      value: _vm.autoExposure,
      callback: function ($$v) {
        _vm.autoExposure = $$v;
      },
      expression: "autoExposure"
    }
  })], 1), _vm.autoExposure == '0' && !_vm.isDisabled('exposureRange') && !_vm.isDisabled('exposure') ? _c('div', {
    staticClass: "autoFocusValue"
  }, [_c('span', {
    staticClass: "exposure"
  }, [_vm._v(_vm._s(_vm.$t("anywhereSetting.exposureValue")))]), _c('div', {
    staticClass: "sliderContent"
  }, [_c('el-slider', {
    attrs: {
      "show-input-controls": false,
      "step": 0.01,
      "min": _vm.anyWhereSetObj.exposureRange && Number(JSON.parse(_vm.anyWhereSetObj.exposureRange).exposureMin),
      "max": _vm.anyWhereSetObj.exposureRange && Number(JSON.parse(_vm.anyWhereSetObj.exposureRange).exposureMax)
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.exposure, 'exposure');
      }
    },
    model: {
      value: _vm.exposure,
      callback: function ($$v) {
        _vm.exposure = $$v;
      },
      expression: "exposure"
    }
  }), _c('el-input', {
    attrs: {
      "type": "number",
      "show-input-controls": false
    },
    on: {
      "change": function ($event) {
        return _vm.changeInputValue(_vm.inputExposure, 'exposure');
      },
      "input": function ($event) {
        _vm.exposure = Number(_vm.exposure);
      }
    },
    model: {
      value: _vm.inputExposure,
      callback: function ($$v) {
        _vm.inputExposure = $$v;
      },
      expression: "inputExposure"
    }
  })], 1)]) : _vm._e()])])])]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.displayPrePosition,
      expression: "displayPrePosition"
    }],
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": () => {
        _vm.displayPrePosition = false;
        _vm.activeType = '';
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('anywhereSetting.del')))]), _c('el-button', {
    staticClass: "green",
    on: {
      "click": function ($event) {
        return _vm.saveDegree('');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('anywhereSetting.save')))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };